<template>
  <div>
    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>
    <div slot="title">
      <h2>Solicitudes de Evaluación</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <br />
        <div class="row">
          <div class="col-3">
            <router-link to="/SIAP/NuevaSolicitud">
              <button type="button" class="form-control">
                <i class="fa fa-plus-square"></i><span class="label label-default" style="margin-left:5px;">Nueva Evaluación</span>
              </button>
            </router-link>
          </div>
        </div>
        <div class="row" style="margin-top:100px;">
          <div class="col-4">
            <h5><span class="label label-default">Listado de Solicitudes</span></h5>
          </div>
        </div>
        <div class="row">
          <div class="col-10">
            <table class="table table-striped table-light table-hover" id="tablaSolicitudes">
              <thead class="thead-dark">
                <tr>
                  <th>ID Solicitud</th>
                  <th>Estatus Solicitud</th>
                  <th>Fecha de Creación</th>
                  <th>Progreso</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='solicitud in SolicitudesEvaluacion'>
                  <td>{{ solicitud.IdSolicitud }}</td>
                  <td>{{solicitud.EstatusSolicitud}}</td>
                  <td>{{solicitud.FechaCreacion}}</td>
                  <td>{{solicitud.EvaluacionesConcluidas}}/{{solicitud.CantidadEvaluados}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-question-circle' @click='mostrarDetalles(solicitud.IdSolicitud,solicitud.evaluaciones)' />
                    <i class='fa fa-info-circle' @click='verDetalles(solicitud.IdSolicitud)' />
                    <!--<i class='fa fa-edit' v-if="solicitud.EstatusSolicitudId == 1" @click='editarSolicitud(solicitud.IdSolicitud)' /><i class='fa fa-info-circle' @click='verDetalles(solicitud.IdSolicitud)' />-->
                    <i class='fa fa-trash' @click='pedirConfirmacion(solicitud.IdSolicitud)' title="Desactivar Solicitud de Evaluación" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal fade" id="modalDetalles" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalDetalles"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div id="cuerpoModalDetalles" class="col-form-label"></div>
                <br />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //import Layout from '@/components/SIAP/Comun/Plantilla.vue';
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'

  export default {
    data() {
      return {
        SolicitudesEvaluacion: [],
        IdSolicitudEvaluacionSeleccionada: null
      }
    },
    components: {
      //Layout
      ModalConfirmacion: catalogos.SIAP.ModalConfirmacion
    },
    methods: {
      pedirConfirmacion: function (id) {
        var mensaje = "¿Está seguro de desactivar la solicitud de evaluación #"+id+"?"
        var titulo = "Confirmación de desactivación"
        this.IdSolicitudEvaluacionSeleccionada = id
        this.$refs.modalConfirmacion.mostrar(titulo, mensaje, this.desactivarSolicitudEvaluacion);
      },
      desactivarSolicitudEvaluacion: function () {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        
        var peticion = {
          "esPrueba": false,
          "SolicitudEvaluacionId": this.IdSolicitudEvaluacionSeleccionada
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.DesactivarSolicitudEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.buscarSolicitudes()
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarSolicitudes: function (event) {//Obtiene las solicitudes de evaluación
        //carga los datos de la solicitud
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetSolicitudes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {

          if (response.data.SiHayError == false) {
            console.log(response)
            this.SolicitudesEvaluacion = response.data.SolicitudesEvaluacion//carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla("tablaSolicitudes", 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      mostrarDetalles: function (id, evaluaciones) {//abre un modal que muestra los detalles de la solicitud de evaluacion en base a su id
        var lista = '<table class="table table-striped table-light table-hover" id="tablaSolicitudes">' +
          '<thead class="thead-dark">' +
          '<tr>' +
          '<th>Evaluado</th>' +
          '<th>Fecha Limite</th>' +
          '<th>Periodo a Evaluar</th>' +
          '</tr>' +
          '</thead>' +
          '<tbody class="text-dark">';//crea la "plantilla" de la tabla que despliega la información de la solicitud de evaluaciones
        evaluaciones.forEach(function (evaluacion) {//itera a traves de las evaluaciones de la solicitud
          lista += "<tr><td>" + evaluacion.nombreEvaluado + "</td>" +
            "<td>" + evaluacion.FechaLimiteEntregaString + "</td>" +
            "<td>" + evaluacion.FechaInicioPeriodoEvaluacionString + " - " + evaluacion.FechaFinPeriodoEvaluacionString + "</td></tr>"
        })
        lista += "</tbody></table>"
        var titulo = "Solicitud #" + id
        $('#cuerpoModalDetalles').html(lista)
        $('#tituloModalDetalles').html(titulo)//inserta la información dentro del modal
        $('#modalDetalles').modal()//Despliega el modal
      },
      editarSolicitud: function (idSolicitud) {//Redirige al usuario a la página editar solicitud enviando como parametro el id de la solicitud
        this.$router.push({
          name: 'NuevaSolicitud',
          params: { idSolicitud: idSolicitud }
        })
      },
      verDetalles: function (idSolicitud) {//Redirige al usuario a la página ver detalle de solicitud enviando como parametro el id de la solicitud
        this.$router.push({
          name: 'DetalleSolicitudEvaluacion',
          params: { idSolicitud: idSolicitud }
        })
      }
    }, beforeMount: function () {
      this.buscarSolicitudes()
    }

  }

</script>

<style scoped>
  #cuerpoModalDetalles{
    overflow-y:auto;
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/SolicitudesEvaluacion.vue